export const DESIGN_SYSTEM = 'Design System';
export const ATOMS = `${DESIGN_SYSTEM}/Atoms`;
export const MOLECULES = `${DESIGN_SYSTEM}/Molecules`;
export const ORGANISMS = `${DESIGN_SYSTEM}/Organisms`;

export const FEATURES = 'Features';
export const TEMPLATES = 'Templates';

export const DOCUMENTATION = 'Documentation';
export const BRAND_GUIDE = `${DOCUMENTATION}/Brand Guide`;
export const TECHNICAL = `${DOCUMENTATION}/Technical`;

export const IMAGE_PLACEHOLDER =
    'https://www.hoefenhaag.nl/media/ydyjxqnz/nieuwbouw-vianen-hoefenhaag-home-dorpshart.jpg';
